import { render, staticRenderFns } from "./claimCard.vue?vue&type=template&id=6cd15514"
import script from "./claimCard.vue?vue&type=script&lang=js"
export * from "./claimCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports